import React, { useState, useEffect } from "react";
import "./PartialProducts.css";
import HamburgerMenu from "../../../Components/HamburgerMenu/HamburgerMenu";
import CartIcon from "../../../Components/CartIcon/CartIcon";
import { AiOutlineSearch } from "react-icons/ai";
import { useAuth } from "../../../AuthContext";
import useCart from "../../../Hooks/useCart";
import { useLocation, useNavigate } from "react-router-dom";
import Alert from "../../../Components/Alert/Alert";
import Loading from "../../../Components/Loading/Loading";
import ShopCard from "../../../Components/ShopCard/ShopCard";
import BottomBar from "../../../Components/BottomBar/BottomBar";
import BackBtn from "../../../Components/BackBtn/BackBtn";
import Axios from "axios";
import { useBaseUrl } from "../../../ApiContext";
import useProducts from "../../../Hooks/useProducts";

export default function PartialProducts() {
  const { userToken } = useAuth();
  const baseUrl = useBaseUrl();
  const navigate = useNavigate();
  const location = useLocation();
  const { categorySlug, filteredProducts } = location.state || {};
  const [showAlert, setShowAlert] = useState(false);
  const [alertText, setAlertText] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const { cart } = useCart(userToken);
  const [showHamburgerMenu, setShowHamburgerMenu] = useState(false);
  const { products } = useProducts(
    userToken,
    categorySlug,
    setIsLoading,
    setShowAlert,
    setAlertText
  );
  const [mainProducts, setMainProducts] = useState([]);
  const [hasFilter, setHasFilter] = useState(false);
  const [attrString, setAttrString] = useState("");
  const [priceAttrString, setPriceAttrString] = useState("");

  const hamburgerMenuHandler = () => {
    setShowHamburgerMenu(true);
  };

  const hideMenuHandler = () => {
    setShowHamburgerMenu(false);
  };

  useEffect(() => {
    const fetchPartialProducts = async () => {
      try {
        let response;
        if (filteredProducts) {
          setMainProducts(filteredProducts);
          setIsLoading(false);
          if (filteredProducts.length === 0) {
            setShowAlert(true);
            setTimeout(() => {
              setShowAlert(false);
            }, 2000);
            setAlertText("موردی یافت نشد");
          }
          return;
        } else if (attrString || priceAttrString) {
          response = await Axios.get(
            `${baseUrl}/shop/digikala/${categorySlug}/product-varients?attributes=${priceAttrString}${
              attrString && priceAttrString && `,`
            }${attrString}`,
            {
              headers: {
                Authorization: `Token ${userToken}`,
              },
            }
          );
          setMainProducts(response.data.products);
          setIsLoading(false);
          if (response.data.products.length === 0) {
            setShowAlert(true);
            setTimeout(() => {
              setShowAlert(false);
            }, 2000);
            setAlertText("موردی یافت نشد");
          }
        } else {
          if (products) {
            setMainProducts(products);
            setIsLoading(false);
            if (products.length === 0) {
              setShowAlert(true);
              setTimeout(() => {
                setShowAlert(false);
              }, 2000);
              setAlertText("موردی یافت نشد");
            }
          }
        }
      } catch (error) {
        console.log("Error during getting partial products", error);
        setShowAlert(true);
        setTimeout(() => {
          setShowAlert(false);
        }, 2000);
        setAlertText("خطا در برقراری ارتباط");
      }
    };
    if (userToken) {
      fetchPartialProducts();
    }
  }, [baseUrl, userToken, products, filteredProducts]);

  const handleProductClick = (product) => {
    navigate("/product", {
      state: { baseId: product.base_product_id, productId: product.id, categorySlug },
    });
  };

  const handleFilterClick = () => {
    navigate("/productFilter", {
      state: { categorySlug },
    });
  };

  useState(() => {
    const storedAttrStringJSON = localStorage.getItem("attribute filters");
    const storedPriceStringJSON = localStorage.getItem("price filters");
    if (storedAttrStringJSON || storedPriceStringJSON) {
      setHasFilter(true);
    }
    if (storedAttrStringJSON) {
      setAttrString(storedAttrStringJSON);
    }
    if (storedPriceStringJSON) {
      setPriceAttrString(storedPriceStringJSON);
    }
    localStorage.removeItem("product search value");
  }, []);

  const handleOpenSeach = () => {
    navigate("/productsSearch", { state: { label: "products", categorySlug } });
  };

  return (
    <div className="gymBg bgContainer">
      <HamburgerMenu
        showHamburgerMenu={showHamburgerMenu}
        onHide={hideMenuHandler}
      />
      <div className="blurOverlay">
        <div className="pageWrapper">
          <div className="pageHeader centeredFlex">
            <div className="partialProductsHeaderRight centeredFlex">
              <BackBtn />
              <CartIcon {...cart} />
              <div className="filterIconWrapper">
                {hasFilter && <div className="hasFilterBullet"></div>}
                <img
                  src="/images/filter.svg"
                  alt="filter"
                  className="filterBarIcon"
                  onClick={handleFilterClick}
                />
              </div>
              <AiOutlineSearch
                className="shopSearchIcon"
                onClick={handleOpenSeach}
              />
            </div>
            <img
              src="/images/ic_menu.svg"
              alt="menu"
              className="menuIcon"
              onClick={hamburgerMenuHandler}
            />
          </div>
          <h3 className="productsTitle partialProductsHeading">محصولات</h3>
          {isLoading ? (
            <Loading />
          ) : (
            <div className="productsWrapper scroll centeredFlex">
              {mainProducts &&
                mainProducts.length > 0 &&
                mainProducts.map((product) => (
                  <ShopCard
                    key={product.id}
                    label="partialProduct"
                    {...product}
                    onShopCardClick={() => handleProductClick(product)}
                  />
                ))}
            </div>
          )}
          <Alert alertText={alertText} showAlert={showAlert} />
        </div>
      </div>
      <BottomBar />
    </div>
  );
}
